import BusinessProfileDetails from "./BusniessProfileDetails/BusinessProfileDetails";
import EditBusinesProfile from "./EditBusinesProfile/EditBusinesProfile";

export { BusinessProfileDetails, EditBusinesProfile };
